{
  $(document).on('click', '.download__version--list', function() {
    $(this).next('ul').toggle();
  })
}